// Button Go to Top.
document.addEventListener("DOMContentLoaded", function () {
  const scrollToTopBtn = document.querySelector("#scrollToTopBtn");
  const scrollToTopWrapper = document.getElementById("scroll-to-top-button"); // in case your CSS targets the wrapper
  const rootElement = document.documentElement;
  const modalButton = document.getElementById("openGlobalModal");

  console.log("scrollToTop");

  function getSavedProductsSafe() {
    const raw = localStorage.getItem("savedProducts");
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  function updateModalButtonVisibility() {
    // only run this block if the button exists on this page
    if (!modalButton) return;

    const savedProducts = getSavedProductsSafe();
    const modalCount = savedProducts.reduce((sum, p) => sum + (Number(p?.quantity) || 0), 0);
    const productCountSpan = document.getElementById("productCountSpan");

    modalButton.style.display = modalCount === 0 ? "none" : "block";
    if (productCountSpan) productCountSpan.textContent = modalCount;
  }

  // Run once and then at intervals if you truly need polling.
  updateModalButtonVisibility();
  const visibilityInterval = setInterval(updateModalButtonVisibility, 500);

  function handleScroll() {
    const shouldShow = window.pageYOffset > 300;
    // toggle on the same node your CSS expects
    const target = scrollToTopBtn || scrollToTopWrapper;
    if (!target) return;
    target.classList.toggle("show", shouldShow);
  }

  function scrollToTop() {
    // wide compatibility
    if ("scrollBehavior" in document.documentElement.style && window.scrollTo) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (rootElement && rootElement.scrollTo) {
      rootElement.scrollTo({ top: 0 });
    } else {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }
  }

  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener("click", function (e) {
      e.preventDefault();
      scrollToTop();
    });
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll(); // set initial state

  // Optional: clear interval if this page unloads
  window.addEventListener("beforeunload", () => clearInterval(visibilityInterval));
});

if (navigator.cookieEnabled) {
  console.log("Cookies are enabled ✅");
} else {
  console.log("Cookies are disabled ❌");
}